import React from 'react'

const organizationsContext = React.createContext({});

export { organizationsContext }
